export const DEFAULT_ALL_CHARS =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const DEFAULT_UPPERCASE_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/**
 * @param phone
 * @returns 带星号的手机号码，例如：153****5212
 */
export function phoneWithAsterisk(phone: string): string {
    return phone.replace(/^(.{3}).*(.{4}$)/, "$1****$2");
}

/**
 * 把数字转换成包含两个小数位的数字字符串，如1.00、2.50
 * @param fee
 * @returns
 */
export function feeShow(fee: number): string {
    return (Math.round(fee * 100) / 100).toFixed(2);
}

export function isEmpty(str: string, isTrim: boolean = false): boolean {
    if (!str) return true;
    if (isTrim) str = str.trim();
    return str.length === 0;
}

/**
 * 在指定字符串中随机挑选字符组成指定长度的字符串
 * @param length 随机字符串长度
 * @param characters 指定的字符串
 * @returns 指定长度的字符串
 */
export function nonceStr(
    length: number,
    characters: string = DEFAULT_UPPERCASE_CHARS
): string {
    var result = "";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
        );
    }
    return result;
}

export type ValUnit = {
    val: number;
    unit: string;
};

/**
 * 解析如"10rpx","-20em", "100%", "100"的字符串，分离开值和单位
 * @param valAndUnit 要解析的值，如"10rpx","-20em", "100%", "100"等
 * @returns 分离的值和单位，如{val: 10, unit: "rpx"}，{val: -20, unit: "em"}，
 * {val: 100, unit: "%"}，{val: 100, unit: ""}等
 */
export function parseVal(valAndUnit: string): ValUnit | null {
    if (typeof valAndUnit === "number") return { val: valAndUnit, unit: "" };
    const res = valAndUnit.match(/(-?[\d.]+)([a-z%]*)/);
    if (res)
        return {
            val: res[1] ? parseFloat(res[1]) : 0,
            unit: res[2] ? res[2] : "",
        };
    else return null;
}

/**
 * 如果value为字符串时直接返回value，如果value为数字则返回value+numUnit
 */
export function getSizeStr(value: string | number, numUnit = "rpx"): string {
    if (typeof value === "string") return value;
    else return value + numUnit;
}

/**
 * 在.*+?^${}()|[]\这些字符前添加反斜杠
 */
export function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

/**
 * 以下说到的'<分隔符>'表示'一个或多个连在一起的p标签(<p...></p>)或br标签(<br...>)'
 * 把html格式的段落文本根据<分割符>分割成段落数组，注意，可使用{@link htmlStartWithWrap()}判断
 * 此方法分割出的段落数组中第一段是否是空（即{@link html}}以换<分隔符>开头）
 * @param html html格式的文本
 * @param includeSeparator 数组中是否包含<分割符>
 * @returns 格式是(如果includeSeparator为false时，没有<分隔符>返回)：
 * ```
 *  [
 *      '第一个段落(如果html以<分隔符>开头的话，第一个段落是空字符串)',
 *      '<分割符>',
 *      '第二个段落',
 *      '<分割符>',
 *      ....,
 *      '最后一个段落(如果html以<分隔符>结尾的话，最后一个段落是空字符串)'
 *  ]
 * ```
 */
export function htmlTextSplitLines(
    html: string,
    includeSeparator: boolean = false
): string[] {
    const regex = includeSeparator
        ? /((?:<\/p>(?:<p[^>]*><br[^>]*><\/p>)*<p[^>]*>)+)/
        : /(?:<\/p>(?:<p[^>]*><br[^>]*><\/p>)*<p[^>]*>)+/;
    if (html) return html.split(regex);
    else return [];
}

/**
 * 以下说到的'<分隔符>'表示'一个或多个连在一起的p标签(<p ...></p>)或br标签(<br ...>)'
 * 判断html是否以<分隔符>开头
 * @param html html格式的文本
 * @return 是否以<分隔符>开头
 */
export function htmlStartWithWrap(html: string): boolean {
    if (!html) return false;
    const regex = /^<p[^>]*><br[^>]*>.*/;
    return regex.test(html);
}

/**
 * 把{@link text}中连续多个换行改为1个换行
 */
export function multWrapToOne(text: string): string {
    if (!text) return "";
    return text.replace(/(\r\n|\n|\r)+/g, "\r\n");
}

/**
 * 把{@link text}文本根据行分离到数组中
 */
export function toLines(text: string): string[] {
    if (!text) return [];
    return text.split(/(?:\r\n|\n|\r)+/);
}

/**
 * 找到不在html标签(以'<'开头，以'>'结束)中的第numberTh个target字符的正则表达式
 * @param target 目标
 * @param numberTh 当前行相同目标中的第几个
 * @returns 返回的正则表达式
 */
export function replaceRegex(target: string, numberTh: number): RegExp {
    target = escapeRegExp(target);
    return new RegExp(
        `(?<=(?:(?<!<[^>]*)${target}.*){${numberTh}})(?<!<[^>]*)${target}`
    );
}
